export default __webpack_public_path__ + "static/repeat_background-3d448f3c9663caad815db215daf1c140.png";